import { IBreadcrumb } from './breadcrumbs';
import { IListingSeoData } from './listingSeoData';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { IQueryPuids } from '../../repositories/dailyrent/entities/query_puids/QueryPuids';
import { TPublicWebV1SearchResponse_MlRanking } from '../../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { ISortVariant } from '../../repositories/dailyrent/entities/sort_variant/SortVariant';

export interface IListingOffersState {
  offers: IDailyRentOfferForMobileSite[];
  page: number;
  status: EFetchStatus;
  maxOffersCount: number;
  currentOffersCount: number;
  mlRanking: TPublicWebV1SearchResponse_MlRanking | undefined;
  seoData: IListingSeoData;
  breadcrumbs: IBreadcrumb[] | null;
  hasMoreOffers: boolean;
  puids: IQueryPuids | null;
  /** Варианты сортировки, применимые к текущему запросу (приходят с web/v1/search как есть) */
  sortVariants: ISortVariant[];
}

export enum EFetchStatus {
  /**
   * Листинг ещё не запрашивали — ни на ноде, ни на клиенте (без обещаний загрузки).
   * Значение листинга: emptyListingSuggestions исторически держит «не запрашивали» как null.
   */
  INITIAL = 'initial',
  SUCCESS = 'success',
  FAILURE = 'failure',
  LOADING = 'loading',
}
